import React from 'react';
import { BottomNav } from './BottomNav';
import Sidebar from './Sidebar';

export const Page = ({ children, noNav = false, className = '' }) => (
  <div className={`app-bg min-h-screen ${className}`}>
    {/* Desktop sidebar is always available for navigation; hidden on mobile via its own classes */}
    <Sidebar />
    <div className="lg:pl-[var(--sidebar-width,15rem)] transition-[padding] duration-200">
      <div className={`mx-auto w-full max-w-6xl ${noNav ? 'pb-6' : 'pb-24 lg:pb-8'}`}>{children}</div>
    </div>
    {/* Mobile bottom nav only for primary pages */}
    {!noNav && <BottomNav />}
  </div>
);
